
export function debounce(func, limit) {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(func, limit, ...args);
    }
}

export function throttle(func, limit) {
    let timeout = false;
    return (...funcArgs) => {
        if(timeout) return;
        func(...funcArgs);
        timeout = setTimeout( () => timeout = false, limit);
    }
}
